const mediaItems = [
  {
    title: '斗破苍穹 · 决战云岚',
    desc: '萧炎携异火之力重返云岚宗，与云山的宿命对决终于迎来终章。全新高清水墨特效战斗场景，每一帧都是壁纸级别。',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylized%20manga%20action%20scene%20illustration%2C%20epic%20battle%20between%20two%20warriors%20with%20flame%20and%20wind%20powers%2C%20warm%20orange%20and%20crimson%20dramatic%20lighting%2C%20dynamic%20composition%20with%20speed%20lines%2C%20clean%20minimal%20background%2C%20modern%20anime-inspired%20art%20style%2C%20cinematic%20feel&width=640&height=400&seq=media-01&orientation=landscape',
    stat: '9.8分 · 日读300万',
  },
  {
    title: '狐妖小红娘 · 镜花缘',
    desc: '涂山红红与东方月初的千年羁绊，镜花水月篇以唯美画风诠释了爱情与宿命的永恒主题。',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylized%20romantic%20manga%20scene%20illustration%2C%20two%20characters%20under%20a%20cherry%20blossom%20tree%20with%20magical%20moonlight%2C%20soft%20pink%20and%20gold%20color%20scheme%2C%20dreamy%20atmosphere%2C%20clean%20minimal%20composition%2C%20modern%20anime-inspired%20art%20style&width=640&height=400&seq=media-02&orientation=landscape',
    stat: '9.7分 · 完结纪念',
  },
  {
    title: '一人之下 · 罗天大醮',
    desc: '异人界的盛大赛事在龙虎山拉开帷幕，张楚岚与王也的巅峰对决让所有读者为之沸腾。',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylized%20manga%20tournament%20arena%20scene%20illustration%2C%20martial%20artists%20facing%20off%20in%20an%20ancient%20temple%20setting%2C%20warm%20golden%20and%20deep%20blue%20color%20scheme%2C%20dramatic%20lighting%20with%20dust%20particles%2C%20clean%20minimal%20composition%2C%20modern%20anime-inspired%20art%20style&width=640&height=400&seq=media-03&orientation=landscape',
    stat: '9.7分 · 经典回顾',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-heading text-2xl md:text-3xl text-foreground-950 mb-3">精彩连载</h2>
          <p className="text-sm text-foreground-600">51漫画在线观看热度最高的连载作品精选</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-all group">
              <div className="relative aspect-[16/10] overflow-hidden">
                <img src={item.cover} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2">
                  <span className="px-2 py-1 bg-background-50/90 text-foreground-800 rounded-md text-xs font-medium">{item.stat}</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}